import React, { useContext, useState, useEffect } from "react"
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import RowCertificats from "./RowCertificats";
import Form from "../../components/Forms/Form";
import Loader from "../../components/Loader";
import { CertificateSchema } from "../../components/Forms/schema/YupSchema";
import { CertificatColumn } from "../../components/headerContent";
import { useQuery } from "@tanstack/react-query";
import Table from "../../components/Table";
import { useLocation, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import NumberCard from "../../components/Card/NumberCard";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

export default function Certificats() {
  const { apiUrl, user } = useContext(AuthContext);
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search);
  const certificatId = searchParams.get("certificatId");
  const referrer = searchParams.get("referrer");
  const [filteredData, setFilteredData] = useState([]);
  const { t } = useTranslation();

  // Request to get all certificats
  const getAllCertficats = async () => {
    const res = await axios(`${apiUrl}certificats/`, {
      method: "GET",
      withCredentials: true,
    })
    return res.data
  };

  const certificats = useQuery({
    queryKey: ["certificats"],
    queryFn: getAllCertficats
  });

  useEffect(() => {
    if (certificats.data !== undefined && !certificats.data.includes("No data")) {
      if (certificatId) {
        const filteredData = certificats.data.filter(certif => certif.id.toString() === certificatId);
        setFilteredData(filteredData);
      } else {
        setFilteredData(certificats.data);
      }
    }
  }, [certificats.data, certificatId]);

  // Content to create new certificate
  const formContentNew = [
    { id: "certificat", type: "text", title: "Certificat" },
    { id: "type", type: "text", title: "Type" },
      { id: "plaque", type: "text", title: "Plaque" },
    { id: "fonction", type: "text", title: "Fonction" },
    { id: "expiration", type: "date", title: "Expiration" },
    { id: "client", type: "text", title: "Client" },
    { id: "pki", type: "text", title: "Pki" },
  ];

  // Request to create new certificate
  const createNewCertificat = async (data) => {
    const res = await axios(`${apiUrl}certificats/new`, {
      method: "post",
      withCredentials: true,
      data: {
        holding: user.holdingId,
        entreprise: user.entrepriseId,
        ...data,
      },
    })
    return res.data
  };

  return (
    <div className="ecp-container">
      {!certificats.isLoading ? (
        <div className="ecp-container-content">
          {(certificats.isFetched && certificats.data && certificats.data.length === 0) ? (
            <h1 className="page-title">
              <div className="ecp-container">
                <div className="ecp-container-content-error">
                  <div className="error-container">
                    <img src='../assets/ecp_error.svg' alt="icône d'erreur" />
                    <div className="error-container-text">
                      <h1 className="page-title">
                        {t("Aucun certificats disponibles")}
                      </h1>
                      <p className="page-link_home">
                        <Link to="/"> {t("Revenir à l'accueil")}</Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </h1>
          ) : (
            <>
              <div className="ecp-container-content-header">
                <h1 className="page-title">{t('Certificats')}</h1>
                <div className="container-file-saver-csv">
                  <Form
                    formContent={formContentNew}
                    schema={CertificateSchema}
                    submitFunction={createNewCertificat}
                    title="Enregistrer un certificat"
                    action="new"
                  />
                </div>
              </div>
              <section className="page-section">
                <NumberCard title="Certificats disponibles" number={filteredData.length} logo={faCircleCheck} color="#AEC353" stylesIcons="logo-certificats" />
              </section>
              {certificatId && (
                <div className="page-title page-link-timeline">
                  <Link to={`/${referrer}`} className="buttons-ecp button-new"><FontAwesomeIcon icon={faChevronLeft} /> {t('Retour')}</Link>
                </div>
              )}
              <div className='cato-content-table'>
                <Table
                  tableData={filteredData}
                  tableColumns={CertificatColumn}
                  rowComponent={RowCertificats}
                  FileSaverExcelData={[certificats.data]}
                  FileSaverExcelName={'Certificats'}
                  admin={true}
                />
              </div>
            </>
          )}
        </div>
      ) : (
        <Loader />
      )}
    </div>
  );
}
